// Pure product helpers shared by `useProduct` and the sites' own (hook-free) product cards.
// Logic is moved verbatim from `useProduct`; do not change behaviour here without checking every consumer.

export const check_product_availability = (product) => {
  const price = product?.price?.price;
  const count = product?.details?.count;
  return parseInt(price) > 0 && parseInt(count) > 0;
};

export const check_product_offer = (product) => {
  const price = product?.price?.price;
  const offer_price = product?.price?.offer_price;
  return (
    parseInt(offer_price) > 0 &&
    parseInt(price) - parseInt(offer_price) > 0 &&
    product?.price?.has_offer
  );
};
